import { Component } from '@verndale/core';
import Form from '../modules/form';
import { defineCustomElements } from '@duetds/date-picker/dist/loader';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $form: this.el._$('form'),
      $formElements: this.el._$$('.Form__Element'),
      $choiceContainers: this.el._$$('div[data-f-type="choice"]'), // wrapper for checkboxes or radio buttons.
      $dropdowns: this.el._$$('select'),
      $inputFieldContainers: this.el._$$('div[data-f-type="textbox"]'),
      $datePickerContainers: this.el._$$('.FormDateTime'),
      $roleAlertDiv: this.el._$$('div[role="alert"]'),
      $fieldsetContainer: this.el._$$('fieldset')
    };

    this.validationIcons = `<div class="form-input__icon-wrapper">
      <svg viewBox="0 0 12 12" class="form-input__icon form-input__icon-check" role="presentation">
        <use xlink:href="#check"></use>
      </svg>
      <svg viewBox="0 0 12 12" class="form-input__icon form-input__icon-close" role="presentation">
        <use xlink:href="#close"></use>
      </svg>
    </div>`;

    // parse episerver form and apply UE style rules
    this.setupAtomic();
    this.setupHeadings();
    this.setupDatePickers();
    this.setupFormElements();
    this.setupFieldset();
    this.setupRadioButtons();
    this.setupCheckboxes();
    this.setupDropdowns();
    this.setupInputFields();

    new Form(this.dom.$form);
  }

  setupAtomic() {
    this.dom.$roleAlertDiv.forEach(roleAlert => {
      roleAlert.setAttribute('aria-atomic', true);
    });
  }

  setupHeadings() {
    const heading = this.el._$('.episerver-form__heading');
    const copy = this.el._$('.episerver-form__copy');
    const formHeading = this.el._$('.Form__Title');
    const formCopy = this.el._$('.Form__Description');

    if (heading && formHeading) {
      heading.innerHTML = formHeading.innerHTML;
      formHeading.remove();
    }

    if (copy && formCopy) {
      copy.innerHTML = formCopy.innerHTML;
      formCopy.remove();
    }
  }

  setupDatePickers() {
    // register date picker
    defineCustomElements(window);

    this.dom.$datePickerContainers.forEach(datePickerContainer => {
      const datePicker = datePickerContainer._$('.FormDateTime__Input');
      const duetDatePicker = document.createElement('duet-date-picker');

      duetDatePicker.setAttribute('identifier', datePicker.getAttribute('id'));
      datePickerContainer.insertBefore(duetDatePicker, datePicker);
      datePickerContainer._on('click', this.handleDateInputClick.bind(this));
      datePicker.remove();

      duetDatePicker.parentNode.classList.add('form-date');
      duetDatePicker.parentNode._$('label').classList.add('form-input__label');

      duetDatePicker._on('duetChange', this.handleCheckInputFilled.bind(this));
      duetDatePicker._on('duetFocus', this.handleCheckInputFilled.bind(this));
      duetDatePicker._on('duetBlur', this.handleCheckInputFilled.bind(this));
    });
  }

  handleDateInputClick(e) {
    if (!e.target.classList.contains('duet-date__input')) return;

    const duetDatePicker = this.el._$(`[identifier="${e.target.getAttribute('id')}"]`);
    duetDatePicker.show();
  }

  setupFormElements() {
    this.dom.$formElements.forEach(formElement => {
      formElement.classList.add('form-input');
    });
  }

  setupFieldset() {
    this.dom.$fieldsetContainer.forEach(fieldset => {
      if (fieldset.classList.contains('Form__Element')) {
        fieldset.classList.add('form__fieldset');

        const labels = fieldset._$$('label');

        labels.forEach(label => {
          if (label.nextElementSibling && label.nextElementSibling.tagName === 'INPUT') {

            if (label.classList.contains('visually-hidden')) {
              label.classList.remove('visually-hidden');
            }
            const parentDiv = label.parentNode;
            const newDiv = document.createElement('div');

            newDiv.classList.add('form-input__text', 'form-input');
            newDiv.innerHTML += this.validationIcons;

            parentDiv.insertBefore(newDiv, label);
            newDiv.appendChild(label.nextElementSibling);
            newDiv.appendChild(label);
          }
        });
      }
    });
  }

  setupRadioButtons() {
    this.dom.$choiceContainers.forEach(choiceContainer => {
      if (choiceContainer._$('input[type="radio"')) {
        choiceContainer.classList.add('form-radio', 'label');

        choiceContainer._$$('label').forEach(choiceContainer => {
          choiceContainer.innerHTML += '<span role="presentation" class="checkmark"></span>';
        });
      }
    });
  }

  setupCheckboxes() {
    this.dom.$choiceContainers.forEach(choiceContainer => {
      if (choiceContainer._$('input[type="checkbox"')) {
        choiceContainer.classList.add('form-checkbox');

        choiceContainer._$$('label').forEach(choiceContainer => {
          choiceContainer.innerHTML += `<div role="presentation" class="checkmark">
            <svg viewBox="0 0 12 12" role="presentation">
              <use xlink:href="#check" />
            </svg>
          </div>`;
        });
      }
    });
  }

  setupDropdowns() {
    this.dom.$dropdowns.forEach(dropdown => {
      dropdown.parentElement.classList.add('form-select');
    });
  }

  setupInputFields() {
    const containers = [...this.dom.$inputFieldContainers, ...this.dom.$fieldsetContainer];

    containers.forEach(container => {
      container._$$('input[type="text"], input[type="number"], textarea').forEach(inputField => {
        inputField.classList.add('form-input__field');

        inputField._on('change', this.handleCheckInputFilled.bind(this));
        inputField._on('keyup', this.handleCheckInputFilled.bind(this));
        inputField._on('click', this.handleCheckInputFilled.bind(this));
        inputField._on('focusout', this.handleCheckInputFilled.bind(this));

        inputField.click();
      });
    });
  }

  handleCheckInputFilled(e) {
    const label = e.target.parentElement._$('label');
    const isFilled = e.target.value || e.target.placeholder || document.activeElement === e.target;

    label.classList.toggle('float-label', isFilled);
    e.target.classList.toggle('form-input__field--filled', isFilled);
  }
}

export default Module;
